"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMainMouseButton = isMainMouseButton;
exports.isTouchEvent = isTouchEvent;
exports.getEventClientPos = getEventClientPos;
exports.triggerInput = triggerInput;
const point_1 = require("./point");
/**
 * Проверяет, является ли событие событием нажатия основной кнопки мыши.
 * @param event Событие.
 * @return Является ли.
 */
function isMainMouseButton(event) {
    return event?.button === 0;
}
/**
 * Проверяет, является ли переданное событие touch-событием.
 * @param event Событие.
 * @return Является ли переданное событие touch-событием.
 */
function isTouchEvent(event) {
    return Boolean(event?.touches);
}
/**
 * Берет данные позиции из события.
 * @param event Touch- или Mouse-событие.
 * @return Данные позиции.
 */
function getEventClientPos(event) {
    const source = isTouchEvent(event) ? event.touches[0] : event;
    return (0, point_1.Point)(source?.clientX, source?.clientY);
}
/**
 * Вызывает событие input на элементе input/textarea/select.
 * Полезен когда необходимо сообщить React'у что был произведен ввод значения пользователем.
 * За основу взята реализация отсюда: https://stackoverflow.com/a/47409362/13166471.
 * @param element Элемент.
 * @param value Значение.
 */
function triggerInput(element, value) {
    const constructors = [HTMLInputElement, HTMLSelectElement, HTMLTextAreaElement];
    let constructor = null;
    for (const item of constructors) {
        if (element instanceof item) {
            constructor = item;
        }
    }
    if (constructor) {
        const setValue = Object.getOwnPropertyDescriptor(constructor.prototype, 'value')?.set;
        if (setValue) {
            setValue.call(element, value);
            element.dispatchEvent(new Event('input', { bubbles: true }));
        }
    }
}
//# sourceMappingURL=events.js.map